import { Outlet } from "react-router";

import { ExternalRegisterImportContent } from "./ExternalRegisterImportStages";
import {
  mockExternalRegisterImportAdapter,
} from "./externalRegisterImportFixtures";
import { ExternalRegisterImportErrorBoundary } from "./ExternalRegisterImportErrorBoundary";
import { externalRegisterImportLiveAdapter } from "./externalRegisterImportLiveAdapter";
import { ExternalRegisterImportProvider } from "./externalRegisterImportProvider";
import type { ExternalRegisterImportAdapter, ImportCommitRequest } from "./externalRegisterImportTypes";

type ExternalRegisterImportProps = {
  adapter?: ExternalRegisterImportAdapter;
  enableNavigationBlocker?: boolean;
  commitProgressDelayMs?: number | null;
  onCommitRequest?: (request: ImportCommitRequest) => void;
};

export const ExternalRegisterImportFlow = ({
  adapter = externalRegisterImportLiveAdapter,
  enableNavigationBlocker = true,
  commitProgressDelayMs = null,
  onCommitRequest,
}: ExternalRegisterImportProps) => {
  return (
    <ExternalRegisterImportErrorBoundary>
      <ExternalRegisterImportProvider
        adapter={adapter}
        enableNavigationBlocker={enableNavigationBlocker}
        commitProgressDelayMs={commitProgressDelayMs}
        onCommitRequest={onCommitRequest}
      >
        <Outlet />
      </ExternalRegisterImportProvider>
    </ExternalRegisterImportErrorBoundary>
  );
};

export const ExternalRegisterImportRouteContent = () => {
  return <ExternalRegisterImportContent />;
};

export const ExternalRegisterImport = ({
  adapter = mockExternalRegisterImportAdapter,
  enableNavigationBlocker = true,
  commitProgressDelayMs = 0,
  onCommitRequest,
}: ExternalRegisterImportProps) => {
  return (
    <ExternalRegisterImportErrorBoundary>
      <ExternalRegisterImportProvider
        adapter={adapter}
        enableNavigationBlocker={enableNavigationBlocker}
        commitProgressDelayMs={commitProgressDelayMs}
        onCommitRequest={onCommitRequest}
      >
        <ExternalRegisterImportContent />
      </ExternalRegisterImportProvider>
    </ExternalRegisterImportErrorBoundary>
  );
};

export default ExternalRegisterImport;
